module.exports = __webpack_public_path__ + "img/staples-center_exterior.0337f21a.jpg";